import { defineStore } from 'pinia';
import { ref } from 'vue';

import type { WorkerDetail } from '@/modules/worker/types';

export const useWorkerProfileOptimisticStore = defineStore(
	'workerProfileOptimistic',
	() => {
		const workersById = ref<Record<string, WorkerDetail>>({});

		const seedWorker = (worker: WorkerDetail) => {
			workersById.value = { ...workersById.value, [worker.id]: worker };
		};

		const getWorker = (workerId: string): WorkerDetail | null => {
			return workersById.value[workerId] ?? null;
		};

		const clearWorker = (workerId: string) => {
			if (!(workerId in workersById.value)) return;
			const next = { ...workersById.value };
			delete next[workerId];
			workersById.value = next;
		};

		return {
			seedWorker,
			getWorker,
			clearWorker,
		};
	}
);
